import { render, staticRenderFns } from "./CallHistoryComp.vue?vue&type=template&id=f12ff586&scoped=true&"
import script from "./CallHistoryComp.vue?vue&type=script&lang=js&"
export * from "./CallHistoryComp.vue?vue&type=script&lang=js&"
import style0 from "./CallHistoryComp.vue?vue&type=style&index=0&id=f12ff586&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12ff586",
  null
  
)

export default component.exports